"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectCurrentTabId = exports.selectShowDropdown = void 0;
const reselect_1 = require("reselect");
// eslint-disable-next-line import/prefer-default-export
exports.selectShowDropdown = (0, reselect_1.createSelector)((state) => state.account, (account) => account.showDropDown);
// eslint-disable-next-line import/prefer-default-export
exports.selectCurrentTabId = (0, reselect_1.createSelector)((state) => state.account, (account) => account.currentTabId);
